

import React, {useRef, useState} from 'react';
import { Formik, FormikValues, Form } from 'formik';
import {Button, Tooltip} from 'antd';
import "./uploadDirectReportForm.scss";
import { CaseDetail } from '../../../models/CaseDetail/caseDetail.model';
import { Report } from '../../../models/Report/report.model';
import ReportService from '../../../services/Report/report.service';
import Notification from '../Notification';
import { NotificationTypes } from '../../../enums/notificationTypes';
import {CloudUploadOutlined} from "@ant-design/icons";

interface UploadDirectReportButtonProps {
  reportId?: number;
  caseDetail?: CaseDetail;
  onSuccess?: (values: Report) => void;
  block?: boolean;
  size?: "small" | "middle" | "large";
  /** Ensures ant-btn-default class (needed for viewer dark theme overrides) */
  buttonType?: "default" | "primary" | "link" | "text" | "dashed" | "ghost";
}

function UploadDirectReportButton({ reportId, caseDetail, onSuccess, block, size = "middle", buttonType = "default" }: UploadDirectReportButtonProps) {

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [fileUploading, setFileUploading] = useState(false);

  const handleButtonClick = () => {
    fileInputRef.current?.click(); // opens file picker
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    handleUploadFile(file);
  };


  const handleUploadFile = async (file: File) => {
    try {
      setFileUploading(true);
      const formData = new FormData();
      formData.append('file', file);
      if(reportId) {
        const extension = file.name.split('.').pop() || '';
        ReportService.getSignedURLForDirectReport(
          reportId,
          extension,
          (response: {
          url: string;
          filePath: string;
        }) => {
          if(response?.url && response?.filePath) {
            fetch(response.url, {
              method: 'PUT',
              headers: {
                'Content-Type': file.type,
              },
              body: file,
            }).then((res) => {
              if(res.ok && reportId) {
                ReportService.uploadDirectReport(
                  reportId,
                  response.filePath,
                  (report: Report) => {
                      Notification({
                        message: "Report published",
                        type: NotificationTypes.SUCCESS,
                      });
                    onSuccess?.(report);
                  }, () => {
                  }, () => {
                    setFileUploading(false);
                  }
                )
              }
            }).catch(() => {
              setFileUploading(false);
            }).finally(() => {

            });
          }
        }, () => {
          setFileUploading(false);
        }, () => {});
      }
    } catch (error) {
      setFileUploading(false);
      // Do nothing
    }

  };

  return (
    <div className="upload-direct-report-button">
      <Button type={buttonType}
        onClick={handleButtonClick}
        loading={fileUploading}
        disabled={fileUploading}
        icon={<CloudUploadOutlined />}
        block={block}
        size={size}
      >
        Upload Report
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.doc,.docx"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>      
  );
}

export default UploadDirectReportButton;